<template>
  <div class="header">
    <el-button-group>
      <el-button
        :loading="state.isSaveBtnLoading"
        size="small"
        @click="handleClickBack"
        icon="el-icon-arrow-left"
        :title="$t('lcd.Editor.back')"
      >
      </el-button>
      <el-button
        size="small"
        @click="handleClickUndo"
        :title="$t('lcd.Editor.undo')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe637;</span
        >
      </el-button>
      <el-button
        size="small"
        @click="handleClickRedo"
        :title="$t('lcd.Editor.redo')"
        style="margin: 0"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe638;</span
        >
      </el-button>
    </el-button-group>
    <el-input
      v-model="state.programInfo.templateName"
      size="small"
      style="width: 160px; margin-left: 12px"
      :title="state.programInfo.tempalteName"
    />
    <!-- {{state.programInfo}} -->

    <el-select
      v-model="resolution"
      disabled
      size="small"
      @change="handleChange"
      style="width: 120px; margin-left: 12px"
    >
      <el-option
        v-for="item in resolutionList"
        :key="item.value"
        :label="item.value"
        :value="item.value"
      />
    </el-select>
    <el-button-group style="margin-left: 12px">
      <el-button
        :disabled="!activeComponent"
        size="small"
        :title="$t('lcd.Editor.Align Left')"
        @click="handleAlign('left')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe609;
        </span>
      </el-button>
      <el-button
        :disabled="!activeComponent"
        size="small"
        :title="$t('lcd.Editor.Align Horizontal Center')"
        @click="handleAlign('hc')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe605;
        </span>
      </el-button>
      <el-button
        :disabled="!activeComponent"
        size="small"
        :title="$t('lcd.Editor.Align Right')"
        @click="handleAlign('right')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe606;
        </span>
      </el-button>
      <el-button
        :disabled="multiCom.length < 3"
        size="small"
        :title="$t('lcd.Editor.Horizontal Average')"
        @click="handleAlign('ha')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe602;
        </span>
      </el-button>
    </el-button-group>
    <el-button-group style="margin-left: 12px">
      <el-button
        :disabled="!activeComponent"
        size="small"
        :title="$t('lcd.Editor.Align Top')"
        @click="handleAlign('top')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe607;
        </span>
      </el-button>
      <el-button
        :disabled="!activeComponent"
        size="small"
        :title="$t('lcd.Editor.Align Vertical Center')"
        @click="handleAlign('vc')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe604;
        </span>
      </el-button>
      <el-button
        :disabled="!activeComponent"
        size="small"
        :title="$t('lcd.Editor.Align Bottom')"
        @click="handleAlign('bottom')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe608;
        </span>
      </el-button>
      <el-button
        :disabled="multiCom.length < 3"
        size="small"
        :title="$t('lcd.Editor.Vertical Average')"
        @click="handleAlign('va')"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe603;
        </span>
      </el-button>
    </el-button-group>

    <div class="scale">
      <i class="el-icon-minus add" @click="handleMinus"></i>
      <div v-clickoutside="handleHideScaleOption" class="scale-val">
        <div class="number" @click="scaleOptionVisible = true">
          {{ ownProgramData.scale.toFixed(2) }}
        </div>
        <div v-show="scaleOptionVisible" class="option-wrap">
          <div class="triangle" />
          <div class="option" @click="selectScale('适应屏幕')">
            {{ $t("lcd.Editor.Fit To Screen") }}
          </div>
          <div class="option" @click="selectScale('实际大小')">
            {{ $t("lcd.Editor.Actual Size") }}
          </div>
          <div class="divider" />
          <div class="option" @click="selectScale('10%')">10%</div>
          <div class="option" @click="selectScale('25%')">25%</div>
          <div class="option" @click="selectScale('50%')">50%</div>
          <div class="option" @click="selectScale('75%')">75%</div>
          <div class="option" @click="selectScale('100%')">100%</div>
          <div class="option" @click="selectScale('150%')">150%</div>
          <div class="option" @click="selectScale('200%')">200%</div>
        </div>
      </div>
      <i class="el-icon-plus add" @click="handleAdd"></i>
      <i class="el-icon-view view" @click="toggleRuler"></i>
    </div>
    <el-button-group style="float: right">
      <!-- 导入 -->
      <el-button
        size="small"
        class="preview"
        @click="handleImport"
        :title="$t('lcd.Editor.import')"
        style="margin: 8px -1px 0"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe8c7;
        </span>
      </el-button>
      <!-- 导出 -->
      <el-button
        size="small"
        class="preview"
        v-clipboard:copy="copyData"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        @click="handleExport"
        :title="$t('lcd.Editor.export')"
        style="margin: 8px -1px 0"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe8c6;
        </span>
      </el-button>
      <el-button
        size="small"
        class="preview"
        @click="handleClickPreview"
        :title="$t('lcd.Editor.preview')"
        style="margin: 8px -1px 0"
      >
        <span class="icon iconfont" style="font-size: 16px; line-height: 16px"
          >&#xe623;
        </span>
      </el-button>
      <el-button
        class="save"
        :loading="state.isSaveBtnLoading"
        size="small"
        @click="handleClickSave"
        :title="$t('lcd.Editor.save')"
        style="margin: 8px -1px 0"
      >
        <span
          class="icon iconfont"
          style="font-size: 16px; color: #000; line-height: 16px"
          >&#xe616;
        </span>
      </el-button>
    </el-button-group>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import Clickoutside from "../../../utils/clickoutside";
import TumengSvgIcon from "../../svg-icon/src/index.vue";
import eventbus from "../../../utils/eventbus";

export default {
  name: "Header",
  directives: {
    Clickoutside,
  },
  components: {
    TumengSvgIcon,
  },
  data() {
    return {
      // 是否显示缩放选项
      scaleOptionVisible: false,
      state: store.state,
      resolutionList: [
        { predefined: true, value: "1920*1080" },
        { predefined: true, value: "1080*1920" },
        { predefined: true, value: "1366*768" },
        { predefined: true, value: "1280*720" },
        { predefined: true, value: "720*1280" },
        { predefined: true, value: "自定义" },
      ],
      resolution: "",
    };
  },
  computed: {
    ownProgramData() {
      return store.state.programInfo;
    },
    // 多选组件信息
    multiCom() {
      return store.state.multipleComponentList;
    },
    // 多选时的activeComponent
    activeComponent() {
      return store.state.activeComponent;
    },
    copyData() {
      return JSON.stringify(store.state.programInfo.pages)
    }
  },
  created() {
    this.resolution =
      store.state.programInfo.width + "*" + store.state.programInfo.height;
    // console.log(`this.resolution = ${this.resolution}`)
    eventbus.$on("INPUT_RESOLUTION", (arr) => {
      if (arr) {
        this.resolution = arr[0] + "*" + arr[1];
      } else {
        this.resolution =
          store.state.programInfo.width + "*" + store.state.programInfo.height;
      }
    });
  },
  methods: {
    // 改变了分辨率
    handleChange(val) {
      if (val !== "自定义") {
        let [width, height] = val.split("*");
        width = Number.parseInt(width);
        height = Number.parseInt(height);
        store.setProgramSize({ width, height });
      } else {
        // 选择自定义分辨率
        store.updateCustomResolutionDialogVisible(true);
      }
    },
    // 点击返回触发
    handleClickBack() {
      this.$emit("back");
    },
    // 点击保存触发
    handleClickSave() {
      // ESL模板列表页自动刷新
      window.localStorage.setItem('refresh_template_list', 'true');
      this.$emit("save");
    },

     // 点击导入触发
    handleImport() {
      this.$emit("import");
    },
     // 点击导出
    handleExport() {
      // this.$emit("export");
      // 修改直接复制方案
    },
    onCopy(){
      this.$message.success(this.$t("lcd.Editor.exportSuccess"));
    },
    onError(){
      this.$message.error(this.$t("lcd.Editor.exportError"));
    },
    // 撤销
    handleClickUndo() {
      if (store.state.currentProgramInfoIndex > 0) {
        store.undo();
      } else {
        this.$message({
          message: this.$t("lcd.Editor.Cannot be revoked"),
          type: "info",
          showClose: true,
        });
      }
    },
    // 恢复
    handleClickRedo() {
      if (
        store.state.currentProgramInfoIndex <
        store.state.programInfoBakList.length - 1
      ) {
        store.redo();
      } else {
        this.$message({
          message: this.$t("lcd.Editor.Cannot be revert"),
          type: "info",
          showClose: true,
        });
      }
    },
    // 放大画布
    handleAdd() {
      this.ownProgramData.scale = Number(
        (this.ownProgramData.scale + 0.05).toFixed(2)
      );
      this.judgeNavigatorVisible();
    },
    // 缩小画布
    handleMinus() {
      this.ownProgramData.scale = Number(
        (this.ownProgramData.scale - 0.05).toFixed(2)
      );
      this.judgeNavigatorVisible();
    },
    // 是否显示缩放选项的
    handleHideScaleOption() {
      this.scaleOptionVisible = false;
    },
    // 选择了缩放
    selectScale(scale) {
      switch (scale) {
        case "适应屏幕":
          this.ownProgramData.scale = this.state.suitableScale;
          break;
        case "200%":
          this.ownProgramData.scale = 2.0;
          break;
        case "150%":
          this.ownProgramData.scale = 1.5;
          break;
        case "实际大小":
        case "100%":
          this.ownProgramData.scale = 1.0;
          break;
        case "75%":
          this.ownProgramData.scale = 0.75;
          break;
        case "50%":
          this.ownProgramData.scale = 0.5;
          break;
        case "25%":
          this.ownProgramData.scale = 0.25;
          break;
        default:
          this.ownProgramData.scale = 0.1;
          break;
      }
      this.judgeNavigatorVisible();
      store.setCanvasPosition({ canvasLeft: undefined, canvasTop: undefined });
      this.scaleOptionVisible = false;
    },
    // 判断右下角导航要不要显示
    judgeNavigatorVisible() {
      store.updateNavigatorVisible(
        this.ownProgramData.scale > this.state.suitableScale
      );
    },
    // 显示/隐藏ruler
    toggleRuler() {
      store.updateRulerVisible(!this.state.rulerVisible);
    },
    // 点击预览触发
    handleClickPreview() {
      console.log(this.state.programInfo.templateGroup)
      if(this.state.programInfo.templateGroup == 3){ 
        // esl价签模板时
        store.updateActiveComponentIdx(undefined);
        store.updateGoodsListVisible(true);
      } else {
        store.updateActiveComponentIdx(undefined);
        store.updatePreviewVisible(true);
      }
    },

    handleAlign(flag) {
      store.updataMultipleComponentAlign(flag);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/clearfix";
$height: 48px;
.header {
  @include clearfix;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: $height;
  padding: 0 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.24), 0 0 6px rgba(0, 0, 0, 0.08);
  z-index: 10;
  .logo-name {
    float: left;
    width: 142px;
    height: $height;
    line-height: $height;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0 5px;
    /*padding-left: 6px;*/
    img {
      vertical-align: middle;
      width: 100%;
    }
  }
  .el-select {
    margin: 8px 0 0 0px;
  }
  // 设置按钮的样式
  .el-button,
  .undo,
  .redo {
    display: block;
    float: left;
  }
  // 给按钮加顶边距和右边距
  .el-button {
    // margin: 8px 8px 0 0;
    margin: 0 -1px 0 -1px;
    font-size: 16px;
    padding: 7px;
    line-height: 0;
  }
  .el-button.is-disabled {
    background-color: rgb(245, 247, 250);
  }
  // 撤销、恢复按钮样式
  .undo,
  .redo {
    font-size: 24px;
    cursor: pointer;
    margin-top: 8.5px;
    margin-right: 8px;
    transition: 0.1s all;
    &:hover {
      color: #666;
    }
    &:active {
      color: #ccc;
    }
  }
  // 中间的那个div
  .scale {
    @include clearfix;
    position: absolute;
    user-select: none;
    $scale-height: 38px;
    height: $scale-height;
    left: 50%;
    top: 96px;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 0 20px;
    border-radius: 20px;
    // 给图标设置大小
    ::v-deep > .svg-icon {
      font-size: 24px;
    }
    // 设置里边所有的元素都float，高度100%，添加边距
    .add,
    .minus,
    .scale-val,
    .view {
      float: left;
      padding: 0 6px;
      height: 100%;
      &:hover {
        background-color: rgba(0, 0, 0, 0.9);
      }
    }
    .add,
    .minus,
    .view {
      line-height: 38px;
      cursor: pointer;
    }
    // 显示缩放比的div的样式
    .scale-val {
      display: block;
      line-height: $scale-height;
      position: relative;
      overflow: visible;
      .number {
        display: inline-block;
        height: 100%;
      }
      // 包裹选择缩放比的div
      .option-wrap {
        width: 200px;
        position: absolute;
        background-color: rgba(0, 0, 0, 0.8);
        border-radius: 6px;
        padding: 12px 0;
        left: 50%;
        transform: translateX(-50%);
        top: 43px;
        z-index: 105;
        .triangle {
          width: 0;
          height: 0;
          border: 5px solid transparent;
          border-bottom-color: rgba(0, 0, 0, 0.8);
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -10px;
        }
        .divider {
          height: 1px;
          background-color: #fff;
          margin: 4px 10px;
          opacity: 0.7;
        }
        .option {
          width: 100%;
          height: 27px;
          padding: 0 20px;
          opacity: 0.8;
          line-height: 27px;
          text-align: center;
          box-sizing: border-box;
          &:hover {
            background-color: rgba(0, 0, 0, 0.9);
          }
        }
      }
    }
  }
  // // 保存按钮的样式
  // .save {
  //   float: right;
  // }
  // // 预览按钮的样式
  // .preview {

  // }
}
</style>
